// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__2-Agw","vLegacy":"SelectSecondary_vLegacy__3U-PS","error":"SelectSecondary_error__aY3o_","disabled":"SelectSecondary_disabled__2Kcwq"};